<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--tabs">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-toolbar">
          <ul
            class="nav nav-tabs nav-tabs-space-xl nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand"
            role="tablist"
          >
            <li class="nav-item" @click.prevent=" tabs.selected = 0">
              <a class="nav-link" :class="{active: tabs.selected == 0}">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon"
                >
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon id="Bound" points="0 0 24 0 24 24 0 24" />
                    <path
                      d="M12.9336061,16.072447 L19.36,10.9564761 L19.5181585,10.8312381 C20.1676248,10.3169571 20.2772143,9.3735535 19.7629333,8.72408713 C19.6917232,8.63415859 19.6104327,8.55269514 19.5206557,8.48129411 L12.9336854,3.24257445 C12.3871201,2.80788259 11.6128799,2.80788259 11.0663146,3.24257445 L4.47482784,8.48488609 C3.82645598,9.00054628 3.71887192,9.94418071 4.23453211,10.5925526 C4.30500305,10.6811601 4.38527899,10.7615046 4.47382636,10.8320511 L4.63,10.9564761 L11.0659024,16.0730648 C11.6126744,16.5077525 12.3871218,16.5074963 12.9336061,16.072447 Z"
                      id="Shape"
                      fill="#000000"
                      fill-rule="nonzero"
                    />
                    <path
                      d="M11.0563554,18.6706981 L5.33593024,14.122919 C4.94553994,13.8125559 4.37746707,13.8774308 4.06710397,14.2678211 C4.06471678,14.2708238 4.06234874,14.2738418 4.06,14.2768747 L4.06,14.2768747 C3.75257288,14.6738539 3.82516916,15.244888 4.22214834,15.5523151 C4.22358765,15.5534297 4.2250303,15.55454 4.22647627,15.555646 L11.0872776,20.8031356 C11.6250734,21.2144692 12.371757,21.2145375 12.909628,20.8033023 L19.7677785,15.559828 C20.1693192,15.2528257 20.2459576,14.6784381 19.9389553,14.2768974 C19.9376429,14.2751809 19.9363245,14.2734691 19.935,14.2717619 L19.935,14.2717619 C19.6266937,13.8743807 19.0546209,13.8021712 18.6572397,14.1104775 C18.654352,14.112718 18.6514778,14.1149757 18.6486172,14.1172508 L12.9235044,18.6705218 C12.377022,19.1051477 11.6029199,19.1052208 11.0563554,18.6706981 Z"
                      id="Path"
                      fill="#000000"
                      opacity="0.3"
                    />
                  </g>
                </svg>
                {{$t('Profile')}}
              </a>
            </li>
            <li class="nav-item" @click.prevent=" tabs.selected = 1">
              <a class="nav-link" :class="{active: tabs.selected == 1}">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon"
                >
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                    <path
                      d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
                      id="Mask"
                      fill="#000000"
                      fill-rule="nonzero"
                      opacity="0.3"
                    />
                    <path
                      d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
                      id="Mask-Copy"
                      fill="#000000"
                      fill-rule="nonzero"
                    />
                  </g>
                </svg>
                {{$t('Account')}}
              </a>
            </li>
            <li class="nav-item" @click.prevent=" tabs.selected = 2">
              <a class="nav-link" :class="{active: tabs.selected == 2}">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon"
                >
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <rect id="bound" x="0" y="0" width="24" height="24" />
                    <path
                      d="M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z"
                      id="Path-50"
                      fill="#000000"
                      opacity="0.3"
                    />
                    <path
                      d="M12,11 C10.8954305,11 10,10.1045695 10,9 C10,7.8954305 10.8954305,7 12,7 C13.1045695,7 14,7.8954305 14,9 C14,10.1045695 13.1045695,11 12,11 Z"
                      id="Mask"
                      fill="#000000"
                      opacity="0.3"
                    />
                    <path
                      d="M7.00036205,16.4995035 C7.21569918,13.5165724 9.36772908,12 11.9907452,12 C14.6506758,12 16.8360465,13.4332455 16.9988413,16.5 C17.0053266,16.6221713 16.9988413,17 16.5815,17 C14.5228466,17 11.463736,17 7.4041679,17 C7.26484009,17 6.98863236,16.6619875 7.00036205,16.4995035 Z"
                      id="Mask-Copy"
                      fill="#000000"
                      opacity="0.3"
                    />
                  </g>
                </svg>
                {{$t('Change Password')}}
              </a>
            </li>
            <li class="nav-item" @click.prevent=" tabs.selected = 3">
              <a class="nav-link" :class="{active: tabs.selected == 3}">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon"
                >
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <rect id="bound" x="0" y="0" width="24" height="24" />
                    <path
                      d="M6,2 L18,2 C18.5522847,2 19,2.44771525 19,3 L19,12 C19,12.5522847 18.5522847,13 18,13 L6,13 C5.44771525,13 5,12.5522847 5,12 L5,3 C5,2.44771525 5.44771525,2 6,2 Z M7.5,5 C7.22385763,5 7,5.22385763 7,5.5 C7,5.77614237 7.22385763,6 7.5,6 L13.5,6 C13.7761424,6 14,5.77614237 14,5.5 C14,5.22385763 13.7761424,5 13.5,5 L7.5,5 Z M7.5,7 C7.22385763,7 7,7.22385763 7,7.5 C7,7.77614237 7.22385763,8 7.5,8 L10.5,8 C10.7761424,8 11,7.77614237 11,7.5 C11,7.22385763 10.7761424,7 10.5,7 L7.5,7 Z"
                      id="Combined-Shape"
                      fill="#000000"
                      opacity="0.3"
                    />
                    <path
                      d="M3.79274528,6.57253826 L12,12.5 L20.2072547,6.57253826 C20.4311176,6.4108595 20.7436609,6.46126971 20.9053396,6.68513259 C20.9668779,6.77033951 21,6.87277228 21,6.97787787 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,6.97787787 C3,6.70173549 3.22385763,6.47787787 3.5,6.47787787 C3.60510559,6.47787787 3.70753836,6.51099993 3.79274528,6.57253826 Z"
                      id="Combined-Shape"
                      fill="#000000"
                    />
                  </g>
                </svg>
                {{$t('Google Authenticator')}}
              </a>
            </li>
            <li class="nav-item" @click.prevent=" tabs.selected = 4">
              <a class="nav-link" :class="{active: tabs.selected == 4}">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon"
                >
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <rect id="bound" x="0" y="0" width="24" height="24" />
                    <path
                      d="M5,8.6862915 L5,5 L8.6862915,5 L11.5857864,2.10050506 L14.4852814,5 L19,5 L19,9.51471863 L21.4852814,12 L19,14.4852814 L19,19 L14.4852814,19 L11.5857864,21.8994949 L8.6862915,19 L5,19 L5,15.3137085 L1.6862915,12 L5,8.6862915 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z"
                      id="Combined-Shape"
                      fill="#000000"
                    />
                  </g>
                </svg>
                {{$t('Settings')}}
              </a>
            </li>
            <li class="nav-item" @click.prevent=" tabs.selected = 5">
              <a class="nav-link" :class="{active: tabs.selected == 5}">
                {{$t('API Tokens')}}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="kt-portlet__body" style="position:relative">
        <div class="tab-content" ref="cnt">
          <div class="tab-pane" :class="{active: tabs.selected == 0}">
            <form @submit.prevent="onSubmitDetails" autocomplete="off">
              <div class="kt-form kt-form--label-right">
                <div class="kt-form__body">
                  <div class="kt-section kt-section--first">
                    <div class="kt-section__body">
                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">{{$t('Name')}}</label>
                        <div class="col-lg-9 col-xl-6">
                          <input class="form-control" v-model="details.name" type="text" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">{{$t('Surname')}}</label>
                        <div class="col-lg-9 col-xl-6">
                          <input class="form-control" v-model="details.surname" type="text" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">{{$t('Email Address')}}</label>
                        <div class="col-lg-9 col-xl-6">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="la la-at"></i>
                              </span>
                            </div>
                            <input type="text" class="form-control" v-model="details.email_address" />
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">{{$t('Phone Number')}}</label>
                        <div class="col-lg-9 col-xl-6">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="la la-phone"></i>
                              </span>
                            </div>
                            <input type="text" class="form-control" v-model="details.phone_number" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="kt-separator kt-separator--space-lg kt-separator--fit kt-separator--border-solid"
                ></div>
                <div class="kt-form__actions">
                  <div class="row">
                    <div class="col-xl-3 col-lg-3"></div>
                    <div class="col-lg-9 col-xl-6">
                      <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane" :class="{active: tabs.selected == 1}">
            <form @submit.prevent="onSubmitDetails" autocomplete="off">
              <div class="kt-form kt-form--label-right">
                <div class="kt-form__body">
                  <div class="kt-section kt-section--first">
                    <div class="kt-section__body">
                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">{{$t('Username')}}</label>
                        <div class="col-lg-9 col-xl-6">
                          <input
                            class="form-control"
                            v-model="details.username"
                            type="text"
                            autocomplete="false"
                            readonly
                          />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">{{$t('Email Address')}}</label>
                        <div class="col-lg-9 col-xl-6">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="la la-at"></i>
                              </span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              v-model="details.email_address"
                              aria-describedby="basic-addon1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="kt-separator kt-separator--space-lg kt-separator--fit kt-separator--border-solid"
                ></div>
                <div class="kt-form__actions">
                  <div class="row">
                    <div class="col-xl-3 col-lg-3"></div>
                    <div class="col-lg-9 col-xl-6">
                      <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane" :class="{active: tabs.selected == 2}">
            <form @submit.prevent="onSubmitPassword" autocomplete="off">
              <div class="kt-form kt-form--label-right">
                <div class="kt-form__body">
                  <div class="kt-section kt-section--first">
                    <div class="kt-section__body">
                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">{{$t('Current Password')}}</label>
                        <div class="col-lg-9 col-xl-6">
                          <input type="password" class="form-control" v-model="details.password" />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">{{$t('New Password')}}</label>
                        <div class="col-lg-9 col-xl-6">
                          <div class="input-group mb-3">
                            <input
                              ref="pass"
                              type="password"
                              :class="{'form-control': true, 'is-invalid': !passValid}"
                              v-model="newpassword"
                            />
                            <div class="input-group-append" @click="switchPass()">
                              <button class="btn btn-outline-secondary" type="button">
                                <i
                                  class="fa"
                                  :class="{'fa-eye-slash': viewPass, 'fa-eye': !viewPass}"
                                  style="padding:0"
                                ></i>
                              </button>
                            </div>
                          </div>
                          <div
                            class="invalid-feedback d-block"
                            v-if="!passValid"
                          >{{$t("Your password must be at least 6 characters long and needs to contain at minimum one character and one number.")}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="kt-separator kt-separator--space-lg kt-separator--fit kt-separator--border-solid"
                ></div>
                <div class="kt-form__actions">
                  <div class="row">
                    <div class="col-xl-3 col-lg-3"></div>
                    <div class="col-lg-9 col-xl-6">
                      <b-button
                        type="submit"
                        variant="success"
                        :disabled="!canSavePass"
                      >{{$t('Save')}}</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane" :class="{active: tabs.selected == 3}">
            <form @submit.prevent="onSubmitDetails" autocomplete="off">
              <div class="kt-form kt-form--label-right">
                <div class="kt-form__body">
                  <div class="kt-section kt-section--first">
                    <div class="kt-section__body">
                      <div
                        class="m-4"
                        style="text-align:center;width: 100%;"
                      >{{$t('Scan this QR code with your compatible Google Authenticator app...')}}</div>
                      <div style="text-align:center;width: 100%;">
                        <div
                          style="background-color:#fff; padding: 10px; min-width: 220px;min-height: 220px; display:inline-block"
                        >
                          <VueQRCodeComponent
                            :text="provisionUrl"
                            :size="size"
                            class="mb-1"
                            style="min-width: 200px;max-width: 200px"
                            v-if="details.ga_secret"
                          ></VueQRCodeComponent>
                        </div>
                      </div>
                      <div
                        class="m-4"
                        style="text-align:center;width: 100%;"
                      >{{$t('... and type in the code from your app in order to verify if the enrollment was successful.')}}</div>
                      <div class="mx-auto" style="width: 260px;">
                        <div style="display:inline-block; vertical-align: middle;">
                          <b-input-group class="mr-3">
                            <b-input-group-prepend>
                              <b-input-group-text>
                                <i class="icon-lock"></i>
                              </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input
                              v-model="code"
                              type="text"
                              class="form-control"
                              :placeholder="$t('Code')"
                              style="max-width: 100px"
                            />
                          </b-input-group>
                        </div>
                        <b-button variant="brand" size="md" @click="onCheckCode">{{$t('Verify')}}</b-button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="kt-separator kt-separator--border-dashed kt-separator--portlet-fit kt-separator--space-lg"
                  ></div>
                  <div class="kt-section kt-section--first">
                    <div class="kt-section__body">
                      <div class="form-group form-group-last row">
                        <div class="col-xl-3 col-lg-3"></div>
                        <div class="col-lg-9 col-xl-6">
                          <b-form-checkbox
                            class="mb-4"
                            v-model="details.enabled_2fa"
                            :value="true"
                            :unchecked-value="false"
                          >{{$t('Enable two factor authentication')}}</b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="kt-separator kt-separator--space-lg kt-separator--fit kt-separator--border-solid"
                  ></div>
                  <div class="kt-form__actions">
                    <div class="row">
                      <div class="col-xl-3 col-lg-3"></div>
                      <div class="col-lg-9 col-xl-6">
                        <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane" :class="{active: tabs.selected == 4}">
            <form @submit.prevent="onSubmitDetails" autocomplete="off">
              <div class="kt-form kt-form--label-right">
                <div class="kt-form__body">
                  <div class="kt-section kt-section--first">
                    <div class="kt-section__body">
                      <div class="row" style="margin-bottom: 2rem">
                        <div class="col-xl-3 col-lg-3">&nbsp;</div>
                        <div
                          class="col-lg-9 col-xl-6"
                        >{{$t('Modify the visible columns in your tables')}}</div>
                      </div>
                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">{{$t('Table')}}</label>
                        <div class="col-lg-9 col-xl-6">
                          <select class="form-control" v-model="storage.selected">
                            <option disabled selected>{{$t("Select Table")}}</option>
                            <option
                              v-for="item in storage.pages"
                              :key="item.value"
                              :value="item.value"
                            >{{$t(item.text)}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row" v-if="storage.selectedData">
                        <label class="col-xl-3 col-lg-3 col-form-label">{{$t('Columns')}}</label>
                        <div class="col-lg-9 col-xl-6" style="padding-top:calc(0.65rem + 1px)">
                          <div v-if="storage.selectedData.columns">
                            <div v-for="item in storage.selectedData.columns" :key="item.k">
                              <div v-if="item.k != 'selected' && item.k != 'view'">
                                <div class="form-group form-check mb-1">
                                  <label class="form-check-label">
                                    <input
                                      v-model="storage.checkedList"
                                      type="checkbox"
                                      class="form-check-input mr-2"
                                      :value="item.k"
                                    />
                                    {{$t(startCase(item))}}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="kt-separator kt-separator--space-lg kt-separator--fit kt-separator--border-solid"
                  ></div>
                  <div class="kt-form__actions">
                    <div class="row">
                      <div class="col-xl-3 col-lg-3"></div>
                      <div class="col-lg-9 col-xl-6">
                        <b-button
                          class="mr-3"
                          type="button"
                          variant="danger"
                          @click="deleteAllColumns"
                        >{{$t('Clear All Settings')}}</b-button>
                        <b-button
                          type="button"
                          variant="success"
                          @click="saveColumns"
                        >{{$t('Save')}}</b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="tab-pane" :class="{active: tabs.selected == 5}">
            <div class="kt-form kt-form--label-right">
              <div class="kt-form__body">
                <div class="kt-section kt-section--first">
                  <div class="kt-section__body">
                    <div class="row" style="margin-bottom: 2rem">
                      <div class="col-lg-12 col-xl-12">
                        <OwnTokens />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { successConf, errorConf } from "@/shared/notifications";
import VueQRCodeComponent from "vue-qrcode-component";
import startCase from "@/shared/strings";
import OwnTokens from "./OwnTokens";

export default {
  name: "profile",
  components: {
    VueQRCodeComponent,
    OwnTokens
  },
  data: function() {
    return {
      tabs: {
        selected: 0
      },
      details: {
        username: "",
        name: "",
        password: "",
        surname: "",
        email_address: "",
        phone_number: "",
        configured_2fa: false,
        enabled_2fa: false,
        ga_secret: ""
      },
      code: "",
      size: 200,

      viewPass: false,
      newpassword: "",
      passValid: true,

      storage: {
        pages: [],
        selected: "",
        selectedData: null,
        checkedList: []
      }
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    provisionUrl() {
      return `otpauth://totp/backoffice:${
        this.details.username
      }?issuer=backoffice&secret=${encodeURIComponent(this.details.ga_secret)}`;
    },
    canSavePass() {
      if (
        this.passValid &&
        this.details.password &&
        this.details.password.length > 0 &&
        this.newpassword.length > 0
      ) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    const len = localStorage.length;

    const tableNames = {
      "apiImports.fields": "API Imports",
      "audits.fields": "Audits",
      "banks.fields": "Banks",
      "cashRegister.fields": "Cash Register",
      "cashRequired.fields": "Cash Required",
      "cashResults.fields": "Cash Results",
      "companies.fields": "Companies",
      "countries.fields": "Lottery Countries",
      "dmIncome.fields": "Daily/Monthly Income",
      "entityLogs.fields": "Entity Log",
      "expiredWinnings.fields": "Expired Winnings",
      "firewalls.fields": "Lottery Firewall Rulesets",
      "incomePayments.fields": "Income - Payments",
      "lotteryEvents.fields": "Lottery Events",
      "lotteryOffers.fields": "Lottery Offers",
      "lotteryResults.fields": "Lottery Results",
      "lotterySystems.fields": "Lottery Systems",
      "lotterySystemsPerformance.fields": "Lottery Performance",
      "operators.fields": "Cash Collectors",
      "permissions.fields": "Permissions",
      "players.fields": "Players",
      "products.fields": "Products",
      "slots.fields": "Slots",
      "slot-reports.fields": "Slot Reports",
      "receiptsWinnings.fields": "Income - Winnings",
      "returnPlayers.fields": "Return to Players",
      "roles.fields": "Roles",
      "shop-groups.fields": "Shop Groups",
      "shopBalance.fields": "Shop Balance",
      "shopBalanceTX.fields": "Shop Balance Transactions",
      "shops.fields": "Shops",
      "taxedPaidTickets.fields": "Taxed Paid Tickets",
      "tenants.fields": "Tenants",
      "terminals.fields": "Terminals",
      "ticketAuthorizations.fields": "Ticket Authorizations",
      "tickets.fields": "Lottery Tickets",
      "users.fields": "Users",
      "subtypes.fields": "Subtypes",
      "balance.fields": "Balance",
      "cashTransactions.fields": "Cash Transactions",
      "user-activity.fields": "User Activity",
      "user-clocking.fields": "User Clocking"
    };

    const tmp = [];
    for (let i = 0; i < len; i++) {
      const key = localStorage.key(i);
      if (key.indexOf(".fields") > -1) {
        if (typeof tableNames[key] !== "undefined") {
          tmp.push({ text: tableNames[key], value: key });
        } else {
          console.log("Missing naming for table", key);
        }
      }
    }
    this.storage.pages = tmp;
  },
  watch: {
    "storage.selected": {
      handler(newVal, oldVal) {
        if (newVal != oldVal && newVal) {
          const data = JSON.parse(localStorage.getItem(newVal));
          const tmp = [];

          if (data.columns) {
            data.columns.forEach(element => {
              if (
                element.k != "selected" &&
                element.k != "view" &&
                this.isChecked(element)
              ) {
                tmp.push(element.k);
              }
            });
          }
          this.storage.checkedList = tmp;

          this.storage.selectedData = data;
        }
      }
    },
    newpassword: function(newVal) {
      if (
        newVal &&
        newVal.length >= 6 &&
        /\d/.test(newVal) &&
        /[a-zA-Z]/.test(newVal)
      ) {
        this.passValid = true;
      } else if (newVal) {
        this.passValid = false;
      } else {
        this.passValid = true;
      }
    }
  },
  methods: {
    loadData() {
      const loadDet = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("auth/me", this.eid)
        .then(resp => {
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    onCheckCode() {
      const loadDet = this.$loading.open({
        container: this.$refs.cnt
      });
      const data = { code: this.code };
      this.$store
        .dispatch("auth/me2FACheck", data)
        .then(resp => {
          if (resp && resp.data && resp.data.verified) {
            let msg = "Code valid";
            this.code = "";
            this.showSuccessNotification(msg);
          } else {
            let msg = "Code invalid";
            this.showErrorNotification({ message: msg });
          }
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    switchPass() {
      this.viewPass = !this.viewPass;
      if (this.viewPass) {
        this.$refs.pass.setAttribute("type", "text");
      } else {
        this.$refs.pass.setAttribute("type", "password");
      }
    },
    onSubmitDetails() {
      const loadDet = this.$loading.open({
        container: this.$refs.cnt
      });
      const detailsData = JSON.parse(JSON.stringify(this.details));
      this.$store
        .dispatch("auth/meUpdate", detailsData)
        .then(resp => {
          let msg = "Profile updated";
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    onSubmitPassword() {
      const loadDet = this.$loading.open({
        container: this.$refs.cnt
      });
      const detailsData = {
        current_password: this.details.password,
        new_password: this.newpassword
      };
      this.$store
        .dispatch("auth/meUpdatePassword", detailsData)
        .then(resp => {
          let msg = "Password Changed";
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    populateData(u) {
      this.details.username = u.username;
      this.details.name = u.name;
      this.details.surname = u.surname;
      this.details.password = u.password;
      this.details.email_address = u.email_address;
      this.details.phone_number = u.phone_number;
      this.details.configured_2fa = u.configured_2fa;
      this.details.enabled_2fa = u.enabled_2fa;
      this.details.ga_secret = u.ga_secret;
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
    startCase(item) {
      return startCase(item.l ? item.l : item.k);
    },
    isChecked(item) {
      return item.c;
    },
    saveColumns() {
      if (this.storage.selected && this.storage.selectedData) {
        const copy = JSON.parse(JSON.stringify(this.storage.selectedData));
        copy.columns.forEach(el => {
          if (this.storage.checkedList.indexOf(el.k) > -1) {
            el.c = true;
          } else {
            if (el.k != "selected" && el.k != "view") {
              el.c = false;
            }
          }
        });
        localStorage.setItem(this.storage.selected, JSON.stringify(copy));
      }
    },
    deleteAllColumns() {
      Object.entries(localStorage).forEach(([key, val]) => {
        if (key && key.indexOf(".fields") > -1) {
          localStorage.removeItem(key);
        }
      });

      this.storage.pages = [];
      this.storage.selected = "";
      this.storage.selectedData = null;
      this.storage.checkedList = [];
    }
  }
};
</script>

<style lang="scss" scoped>
li.nav-item {
  cursor: pointer;
}
</style>
